
<template>
	<div class="cta_listing">
		<div class="inner">

			<cta-listing-item
				v-for="(cta, index) in JSON.parse(ctas)"
				:key="index"
				:title="cta.title"
				:permalink="cta.link"
				:background="cta.image"
				:category="cta.category"
			>
			</cta-listing-item>

		</div>
	</div>
</template>

<script>
import CtaListingItem from './CtaListingItem.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			show: false,
			currentFilter: 'all',
			visible: true,
		};
	},

	props: {
		size: {
			default: 'one',
		},
		ctas: {},
	},

	computed: {

	},

	watch: {

	},

	methods: {

	},

	components: {
		CtaListingItem,
	},

	created() {

	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.cta_listing {
	display: grid;
	grid-template-columns: repeat(18, 1fr);
	// margin-bottom: 4rem;
	padding: 0;
	grid-column: 2 / span 10;
	background: $signs-teal;

	@media (max-width: 1366px) {
		grid-template-columns: repeat(12, 1fr);
		grid-column: 2 / span 10;
	}

	.inner {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-column: 1 / span 18;
		column-gap: 2rem;
		row-gap: 2rem;

		@media (max-width: $md) {
			grid-template-columns: repeat(10, 1fr);
			grid-column: 1 / span 12;
			column-gap: 0;
		}

		> h2 {
			grid-column: span 3;
			font-size: 2rem;
			margin: 0 0 2rem;
			text-align: center;
			color: #ddd;

			@media (max-width: $md) {
				grid-column: span 10;
				font-size: 1.25rem;
			}

			span {
				font-family: 'GT Sectra', Arial, Helvetica, sans-serif;
				color: $signs-pink;
				font-style: normal;
				font-weight: bold;
			}
		}

		.filter {
			grid-column: span 3;
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			list-style: none;
			margin: 0;
			padding: 0;

			@media (max-width: $md) {
				grid-column: span 10;
				flex-wrap: wrap;
				// row-gap: 1rem;
			}

			h2 {
				margin-right: 0;
				font-weight: bold;
				font-size: 1.5rem;

				a {
					text-decoration: none;
					font-weight: bold;

					&:hover {
						cursor: pointer;
						color: $signs-pink;
					}

					&.current {
						color: $signs-pink;
					}
				}

				&::after {
					content: '|';
					margin-right: 10px;
					margin-left: 10px;
				}

				&:last-child {
					&::after {
						content: '';
						margin-right: 0;
						margin-left: 10px;
					}
				}
			}
		}

		.posts-navigation {
			grid-column: 1 / span 3;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-top: 0;

			@media (max-width: $md) {
				grid-column: span 10;
				flex-wrap: wrap;
				row-gap: 1rem;
			}

			.prev-next {
				&:hover {
					cursor: pointer;
					color: $signs-pink;
				}

				&.previous {
					margin: 0 1rem 0 0;
				}
			}

			h2 {
				font-weight: bold;
				font-size: 1.5rem;
				color: $signs-teal;
			}

			.page-numbers {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0;
				margin: 0 1rem 0 0;
				text-decoration: none;
				color: $signs-teal;
				transition: 0.2s all ease;

				// @media (max-width: $md) {
				// 	padding: 1rem 1.5rem;
				// }

				h2 {
					font-weight: bold;
					font-size: 1.5rem;
				}

				&:hover {
					color: $signs-pink;
					cursor: pointer;
				}

				&.current {
					color: $signs-pink;
				}
			}
		}

		.cta_listing__item {
			&.not_visible {
				display: none;
			}

			&.visible {
				display: flex;
			}
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/CtaListing.vue